// extracted by mini-css-extract-plugin
export default {"centered":"tUeYFb","illustration":"PPwX0R","texts":"CNvwz9","title":"frYvB8","subtitle":"Fd56UV"};